export default {"src":"/_next/static/media/step-2.33792d33.svg","height":357,"width":502,"blurWidth":0,"blurHeight":0};